const promotionGroup = {
  path: 'promotionGroup',
  name: 'promotionGroup',
  meta: {
    menuCode: 'agentPromotionGroup'
  },
  component: () => import('@/views/agent/promotionGroup/promotion-group')
};
export default promotionGroup;
